import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnalyticsDirectivesModule } from '@analytics/events';
import { CoreJssProxyModule } from '@core/jss-proxy';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import {
  NgbAccordionModule,
  NgbCarouselModule,
} from '@ng-bootstrap/ng-bootstrap';
import {
  CSCaptureDirective,
  CSMaskDirective,
} from '@legacy/utils-contentsquare';
import { ScIconPipe } from '@core/jss-utils';

import { GenericOfferBreakdownComponent } from './generic-offer-breakdown/generic-offer-breakdown.component';
import { GenericOfferCarouselIndicatorComponent } from './generic-offer-carousel-indicator/generic-offer-carousel-indicator.component';
import { GenericOfferCarouselComponent } from './generic-offer-carousel/generic-offer-carousel.component';
import { GenericOfferContainerComponent } from './generic-offer-container/generic-offer-container.component';
import { GenericOfferInfoComponent } from './generic-offer-info/generic-offer-info.component';
import { GenericOfferComponent } from './generic-offer/generic-offer.component';
import { GenericPriceInfoComponent } from './generic-price-info/generic-price-info.component';
import { GenericPricingBreakdownComponent } from './generic-pricing-breakdown/generic-pricing-breakdown.component';
import { GenericRatingComponent } from './generic-rating/generic-rating.component';
import { GenericUspsComponent } from './generic-usps/generic-usps.component';
import {
  PriceGroupAccordionComponent,
  PriceGroupAccordionContentDirective,
  PriceGroupAccordionHeaderDirective,
} from './price-group-accordion/price-group-accordion.component';
import { ScGenericOfferContainerComponent } from './sitecore';

const components = [
  GenericOfferComponent,
  GenericRatingComponent,
  GenericOfferContainerComponent,
  GenericUspsComponent,
  GenericOfferBreakdownComponent,
  GenericOfferCarouselComponent,
  GenericOfferCarouselIndicatorComponent,
  GenericPriceInfoComponent,
  GenericOfferInfoComponent,
  GenericPricingBreakdownComponent,
  PriceGroupAccordionComponent,
  PriceGroupAccordionHeaderDirective,
  PriceGroupAccordionContentDirective,
];

@NgModule({
  imports: [
    CommonModule,
    CoreJssProxyModule,
    FontAwesomeModule,
    NgbCarouselModule,
    NgbAccordionModule,
    CommonUiUtilityComponentsModule,
    CSCaptureDirective,
    CSMaskDirective,
    AnalyticsDirectivesModule,
    ScIconPipe,
    ...components,
    ScGenericOfferContainerComponent,
  ],
  exports: components,
})
export class CommonUiProductsModule {}
